import { BaseModel, ID } from 'api'
import { generateRandomKey } from '../../../utils/random'

type Predicate<T> = (value: T, index: number, array: T[]) => boolean

export default class Entity<T extends BaseModel> {
  constructor(private data: T[]) {}

  public get(id: ID) {
    return this.data.find((d) => d.id === id)
  }

  public getAll(predicate?: Predicate<T>) {
    if (!predicate) {
      return this.data
    }
    return this.data.filter(predicate)
  }

  public create(newData: Omit<T, keyof BaseModel>) {
    const id = generateRandomKey()
    const newEntity = { ...newData, id } as T
    this.data.push(newEntity)
    return newEntity
  }

  public update(newData: { id: ID } & Partial<T>) {
    const id = newData.id
    this.data = this.data.map((d) => {
      if (d.id === id) {
        d = { ...d, ...newData }
      }
      return d
    })
    return this.get(id)
  }

  public remove(id: ID) {
    const entity = this.get(id)
    if (!entity) {
      return false
    }
    this.data = this.data.filter((d) => d.id !== id)
    return entity
  }
}
